import mutations from './jumpHostStatusMutation';
import actions from './jumpHostStatusAction';
import getters from './jumpHostStatusGetter';

const state = {
  gridData: {},
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/jumpHostStatus/jumpHostStatusStore.js